import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody } from '@heroui/react';
import { useTranslation } from 'react-i18next';
import GlossaryFormContainer from './GlossaryFormContainer';

interface GlossaryFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  glossaryId?: string | null;
}

const GlossaryFormModal: React.FC<GlossaryFormModalProps> = ({ isOpen, onClose, glossaryId }) => {
  const { t } = useTranslation('admin');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl" placement="center" backdrop="blur" scrollBehavior="inside">
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          {glossaryId ? t('glossaries.modal.edit.title') : t('glossaries.modal.create.title')}
        </ModalHeader>
        <ModalBody>
          <GlossaryFormContainer glossaryId={glossaryId} onSuccess={onClose} onCancel={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default GlossaryFormModal;

